const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'mediaManagement',
        'upload',
        'plupload',
        'plupload'
    ],

    config: {
        mode: 'reportSourceUploader',
        secureRoute: '/~/mblx/reportGenerator',
        startOnFilesAdded: false,
        pluploaderConfig: {
            multi_selection: false,
            url: '/LTR/~/mblx/reportGenerator',
            filters: {
                mime_types: [
                    {
                        title: 'Files',
                        extensions: 'xlsx'
                    }
                ]
            }
        }
    },

    methods: {

        start: function(customParameters = {}){
            if(customParameters){
                const params = this.model._uploader.getOption('multipart_params') || {}
                params.customParameters = JSON.stringify(customParameters || {})
                this.model._uploader.setOption('multipart_params', params)
            }

            if(this.model._uploader.files.length < 1){
                this.performAction(
                    this.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:mblx.reports.missingFile'
                        }
                    }, {
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                );
                return utils.promise.reject();
            }

            this.model._uploader.start()
            return utils.promise.resolve();
        },

        beforeChunkUpload: function(file, post, a, b){
            // last chunk of upload file
            if((post || {}).chunk === (((post || {}).chunks || 0) - 1)){
                var statusController;
                if((statusController = getComponent('statusController'))){
                    statusController.showStatus('status.progress.import');
                }
            }
        },

        uploadComplete: function(){
            var self = this;
            var statusController;
            if((statusController = getComponent('statusController'))){
                statusController.removeStatus();
            }

            // prepare result
            var uploadResponse = this.model.lastResponse || {};
            var generatorResult = uploadResponse.generatorResult || {}
            var hash = generatorResult.hash
            var pdfFilePath = generatorResult.pdfFilePath
            var fileName = generatorResult.fileName

            // everything is fine
            if(hash && pdfFilePath && fileName){
                window.open(
                    `/~/mblx/reportDownload?report=${Buffer.from(JSON.stringify({
                        hash,
                        pdfFilePath,
                        fileName
                    })).toString('base64')}`,
                    '_blank'
                );
            }
            // error handling
            else if(generatorResult.error){
                if(
                    generatorResult.error === 'UTILS_FS_XLSX_STREAM_READER_INVALID_CALLBACK' ||
                    generatorResult.error === 'UTILS_FS_XLSX_STREAM_READER_CHUNK_SIZE'
                ){
                    return self.performAction(
                        self.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:mblx.reports.uploadErrorDueToInvalidConfig'
                            }
                        }, {
                            statusControllerLoadingMessage: '',
                            statusControllerSavingMessage:  ''
                        })
                    );
                } else if(generatorResult.error === 'UTILS_FS_XLSX_STREAM_READER_INVALID_INPUT'){
                    return self.performAction(
                        self.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:mblx.reports.uploadErrorDueToInvalidInput'
                            }
                        }, {
                            statusControllerLoadingMessage: '',
                            statusControllerSavingMessage:  ''
                        })
                    );
                } else if(generatorResult.error === 'UTILS_FS_XLSX_STREAM_READER_HEADER_NOT_FOUND'){
                    return self.performAction(
                        self.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:mblx.reports.uploadErrorDueToMissingHeader'
                            }
                        }, {
                            statusControllerLoadingMessage: '',
                            statusControllerSavingMessage:  ''
                        })
                    );
                } else if(generatorResult.error === 'FEC_MBLX_REPORT_GENERATOR_INVALID_EXTENSION_DETECTED'){
                    return self.performAction(
                        self.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:mblx.reports.invalidExtension'
                            }
                        }, {
                            statusControllerLoadingMessage: '',
                            statusControllerSavingMessage:  ''
                        })
                    );
                } else {
                    return self.performAction(
                        self.prepareAction('message', undefined, {
                            messageDisplay: {
                                message: 'error:mblx.reports.uploadUnknownError'
                            }
                        }, {
                            statusControllerLoadingMessage: '',
                            statusControllerSavingMessage:  ''
                        })
                    );
                }
            } else {
                return self.performAction(
                    self.prepareAction('message', undefined, {
                        messageDisplay: {
                            message: 'error:mblx.reports.uploadCompleteButMissingData'
                        }
                    }, {
                        statusControllerLoadingMessage: '',
                        statusControllerSavingMessage:  ''
                    })
                );
            }

            // reset uploader anyway
            this.model.lastResponse = {}
            this.model._uploader.splice()
        }
    }
}